import { useState } from "react";
import { API } from "../APICalls";

export default function Login(){

    document.getElementsByTagName("body")[0].classList.add("login-page");
    document.getElementsByTagName("body")[0].classList.remove("sidebar-mini");


    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    
    const [logingIn, setLogingIn] = useState(false);


    const doLogin = (event) => {
        event.preventDefault();
        
        if(email == '' || email == null){
            alert('El campo email es obligatorio');
        }
        if(password == '' || password == null){
            alert('El campo password es obligatorio');
        }

        setLogingIn(true);
        API.Login(email, password).then((response) => {
            if(response.ok)
            {
                response.json().then((json) => {
                    localStorage.setItem('apiSesionId', json);
                });
            }
            else{ // Bad Login
                alert("No existe la combinación usuario/contraseña");
                setLogingIn(false);
            }
        })
        .catch(() => {
            alert("Cannot connect to LebenRaffle API");
            setLogingIn(false);
        });
    };



    return (
        <div className="login-box">
            <div className="login-logo">
                <a href="../../index2.html">Leben<b>Raffle</b></a>
            </div>
            <div className="card">
                <div className="card-body login-card-body">
                <p className="login-box-msg">Inicio de sesión</p>

                <form onSubmit={doLogin}>
                    <div className="input-group mb-3">
                    <input type="text" value={email} onChange={e => setEmail(e.target.value)} className="form-control" placeholder="Email/Usuario" />
                    <div className="input-group-append">
                        <div className="input-group-text">
                        <span className="fas fa-user"></span>
                        </div>
                    </div>
                    </div>
                    <div className="input-group mb-3">
                    <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="form-control" placeholder="Password" />
                    <div className="input-group-append">
                        <div className="input-group-text">
                        <span className="fas fa-lock"></span>
                        </div>
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-12">
                        {logingIn ? (
                            <button type="submit" className="btn btn-primary btn-block disabled"><i className="fas fa-spinner fa-spin"></i> Iniciando sesión</button>
                        ) : (
                            <button type="submit" className="btn btn-primary btn-block">Login</button>
                        )}
                    </div>
                    </div>
                </form>
                </div>
            </div>
        </div>
    );
}